import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "bf-password-reset-request-form" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "login-input-email",
  class: "form-label"
}, "Deine E-Mail-Adresse", -1)
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Passwort zurücksetzen ")
const _hoisted_7 = {
  key: 0,
  class: "fas fa-spin fa-spinner"
}
const _hoisted_8 = {
  key: 1,
  class: "alert alert-success mt-3 mb-0"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check me-1" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Wenn ein Konto unter dieser E-Mail-Adresse existiert, wurde eine E-Mail zum Zurücksetzen des Passworts an diese Adresse gesendet. ")
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"])),
      novalidate: "",
      ref: "form",
      class: "pt-3"
    }, [
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.error), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          type: "email",
          class: _normalizeClass(["form-control", {'disabled': _ctx.loading || _ctx.success}]),
          disabled: _ctx.loading || _ctx.success,
          id: "login-input-email",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.email) = $event))
        }, null, 10, _hoisted_5), [
          [
            _vModelText,
            _ctx.form.email,
            void 0,
            { trim: true }
          ]
        ])
      ]),
      _createElementVNode("a", {
        href: "#",
        onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"])),
        class: _normalizeClass(["btn btn-primary", {'disabled': _ctx.loading || _ctx.success}])
      }, [
        _hoisted_6,
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("i", _hoisted_7))
          : _createCommentVNode("", true)
      ], 2),
      (_ctx.success)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11))
        : _createCommentVNode("", true)
    ], 544)
  ]))
}